import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('profile', 'mfa-confirmation');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'mfa_confirmations',
  type: 'post',
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/profiles/mfa-confirmations.js